import { NgModule, enableProdMode } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { HttpModule } from "@angular/http";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule, Routes } from "@angular/router";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { AppComponent } from "./app.component";
import { AuthenticationComponent } from "./authentication/authentication.component";
import { PurchaseFormComponent } from "./purchaseForm/purchaseForm.component";
import { ManagerManagementComponent } from "./managerManagement/managerManagement.component";
import { DepartmentComponent } from "./department/department.component";
import { UserComponent } from "./user/user.component";

import { AirQuoteFormComponent } from "./airQuoteForm/airQuoteForm.component";
import { AirQuoteHistoryComponent } from "./airQuoteHistory/airQuoteHistory.component";
import { AirQuoteApprovalComponent } from "./airQuoteApproval/airQuoteApproval.component";
import { AirQuoteTrafficComponent } from "./airQuoteTraffic/AirQuoteTraffic.component";

import { LoadingComponent } from "./loading/loading.component";

import { GlCodeComponent } from "./glcodeManagement/glcode.component";

import { DefaultAuth, BudgetManagerAuth, PurchaserAuth, ApManagerAuth, EditAuth, AirFreightPurchaserAuth, DefaultAirFreightAuth, AirFreightQuoteApproverAuth, AirFreightTrafficMemberAuth } from "./authentication/authGuard.component";
import { AuthenticationService } from "./authentication/authentication.service";
import { ToastModule } from "ng2-toastr/ng2-toastr";
import { Constants } from "./constants/constants";
import { PurchaseHistoryComponent } from "./purchaseHistory/purchaseHistory.component";
import { FilterPurchaseHistory, SortPipe, DatePipe, HighlightPipe, UrlEncode } from "./pipes/filters";
import { ManagerApprovalComponent } from "./managerApproval/managerApproval.component";
import { PurchaserApprovalComponent } from "./purchaserApproval/purchaserApproval.component";
import { PurchasePrintComponent } from "./purchaserPrint/purchaserPrint.component";
import { PurchaseHistoryService } from "./purchaseHistory/purchaseHistory.service";
import { Ng2PaginationModule } from "ng2-pagination";
import { HttpClient } from "./authentication/httpClient";
import { ConfigService } from "./authentication/configureservice.service";
import { HttpClientModule } from '@angular/common/http';

const host = window.location.hostname;
if ((host.includes("forms.control4.com") || host.includes("forms.snapone.com")))
	enableProdMode();

//routes made easy. suck it. order matters
const appRoutes: Routes = [
	{ path: "purchase", component: PurchaseFormComponent, canActivate: [DefaultAuth] },
	{ path: "purchase/:approvalId", component: PurchaseFormComponent, canActivate: [EditAuth] },
	{ path: "savedPurchases", component: PurchaseHistoryComponent, canActivate: [DefaultAuth] },
	{ path: "savedPurchases/:searchTerm", component: PurchaseHistoryComponent, canActivate: [DefaultAuth] },
	{ path: "managers", component: ManagerManagementComponent, canActivate: [ApManagerAuth] },
	{ path: "departments", component: DepartmentComponent, canActivate: [ApManagerAuth] },
	{ path: "glcode", component: GlCodeComponent, canActivate: [ApManagerAuth] },
	{ path: "history", component: PurchaseHistoryComponent, canActivate: [DefaultAuth] },
	{ path: "history/:searchTerm", component: PurchaseHistoryComponent, canActivate: [DefaultAuth] },
	{ path: "managerApproval", component: ManagerApprovalComponent, canActivate: [BudgetManagerAuth] },
	{ path: "managerApproval/:searchTerm", component: ManagerApprovalComponent, canActivate: [BudgetManagerAuth] },
	{ path: "purchaserApproval", component: PurchaserApprovalComponent, canActivate: [PurchaserAuth] },
	{ path: "purchaserApproval/:searchTerm", component: PurchaserApprovalComponent, canActivate: [PurchaserAuth] },
    { path: "purchaserPrint/:approvalId", component: PurchasePrintComponent, canActivate: [PurchaserAuth] },

    { path: "airQuote", component: AirQuoteFormComponent, canActivate: [DefaultAirFreightAuth] },
    { path: "airQuote/:quoteId", component: AirQuoteFormComponent, canActivate: [AirFreightPurchaserAuth] },
    { path: "airQuoteHistory", component: AirQuoteHistoryComponent, canActivate: [AirFreightPurchaserAuth] },
    { path: "airQuoteHistory/:searchTerm", component: AirQuoteHistoryComponent, canActivate: [AirFreightPurchaserAuth] },
    { path: "airQuoteApproval", component: AirQuoteApprovalComponent, canActivate: [AirFreightQuoteApproverAuth] },
    { path: "airQuoteApproval/:searchTerm", component: AirQuoteApprovalComponent, canActivate: [AirFreightQuoteApproverAuth] },
    { path: "airTraffic", component: AirQuoteTrafficComponent, canActivate: [AirFreightTrafficMemberAuth] },
    { path: "airTraffic/:searchTerm", component: AirQuoteTrafficComponent, canActivate: [AirFreightTrafficMemberAuth] },
	{ path: "", component: AuthenticationComponent }
];

var filters = [FilterPurchaseHistory, SortPipe, DatePipe, HighlightPipe, UrlEncode];
var components = [AppComponent, AuthenticationComponent, PurchaseFormComponent, ManagerManagementComponent, UserComponent, PurchaseHistoryComponent, ManagerApprovalComponent, PurchaserApprovalComponent, DepartmentComponent, PurchasePrintComponent, AirQuoteFormComponent, AirQuoteHistoryComponent, AirQuoteApprovalComponent, AirQuoteTrafficComponent, LoadingComponent, GlCodeComponent];
var providers = [AuthenticationService, DefaultAuth, BudgetManagerAuth, PurchaserAuth, ApManagerAuth, EditAuth, Constants, PurchaseHistoryService, AirFreightPurchaserAuth, DefaultAirFreightAuth, AirFreightQuoteApproverAuth, AirFreightTrafficMemberAuth, HttpClient, ConfigService];

@NgModule({
	imports: [BrowserModule, HttpModule, FormsModule, ReactiveFormsModule, RouterModule.forRoot(appRoutes, { useHash: true }), ToastModule, Ng2PaginationModule, BrowserAnimationsModule, HttpClientModule],
	declarations: [components, filters],
	providers: [providers],
	bootstrap: [AppComponent]
})
export class AppModule { }